import { useQuery } from '@tanstack/react-query';
import { DashboardShell } from '@/components/layout/DashboardShell';
import { BestStudentsWidget } from '@/components/admin/reports/BestStudentsWidget';
import { WorstStudentsWidget } from '@/components/admin/reports/WorstStudentsWidget';
import { AttendanceTrendGraph } from '@/components/admin/reports/AttendanceTrendGraph';
import { PersonReportPicker } from '@/components/admin/reports/PersonReportPicker';
import ReportGenerator from '@/components/admin/reports/ReportGenerator';
import { adminService } from '@/services/admin';

export default function AdminReportsStudentsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['school-attendance-trend', 8],
    queryFn: () => adminService.getSchoolAttendanceTrend({ months: 8 }),
  });

  return (
    <DashboardShell title="Student Reports" role="admin">
      <div className="space-y-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <BestStudentsWidget />
          <WorstStudentsWidget />
        </div>
        <AttendanceTrendGraph
          title="Student attendance over time"
          caption="Active students. Present, absent, and rate."
          data={data?.months}
          isLoading={isLoading}
        />
        <PersonReportPicker kind="student" />
        <ReportGenerator />
      </div>
    </DashboardShell>
  );
}
